import React from 'react';
import { ArrowRightIcon, LightbulbIcon, RefreshCwIcon } from 'lucide-react';
import { Button } from '../common/Button';
interface HomeHeroProps {
  lastUpdated: string;
  refreshing: boolean;
  onRefresh: () => void;
  insight: string;
  onOpenInsights: () => void;
}
export function HomeHero({
  lastUpdated,
  refreshing,
  onRefresh,
  insight,
  onOpenInsights
}: HomeHeroProps) {
  return <section className="relative mb-8" data-id="element-255" data-mp="2wudaodh7sn40">
      <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between" data-id="element-256" data-mp="2wun64gl13mh3">
        <div data-id="element-257" data-mp="31sooezamrhri">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-subtle" data-id="element-258" data-mp="31sezzg58hinx">Welcome back</p>
          <h1 className="mt-2 font-display text-[40px] font-bold leading-[1.05] tracking-tight text-accent" data-id="element-259" data-mp="2n420i96xthoo">
            Call{' '}
            <span className="bg-gradient-to-r from-bright to-accent-light bg-clip-text text-transparent" data-id="element-260" data-mp="3ft98dysa7jml">Command Center</span>
          </h1>
          <p className="mt-2 max-w-xl text-[15px] text-muted" data-id="element-261" data-mp="3kkhikx1fr90t">
            An overview of your team's call activity, performance, and key insights.
          </p>
        </div>

        <div className="flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-262" data-mp="jwxeyn5ifh5f">
          <div className="flex items-center gap-2" data-id="element-263" data-mp="xnj0ykq9g77j">
            <span className="whitespace-nowrap text-xs text-subtle" aria-live="polite" data-id="element-264" data-mp="xp3v498nxo4v">
              Last updated {lastUpdated}
            </span>
            <Button iconOnly onClick={onRefresh} disabled={refreshing} aria-label="Refresh data" data-id="element-265" data-mp="17lqhj2gn0n90">
              <RefreshCwIcon className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} aria-hidden data-id="element-266" data-mp="12mm41zmok3cv" />
            </Button>
          </div>

          <button type="button" onClick={onOpenInsights} className="group flex w-full items-center gap-3 rounded-2xl border border-line bg-surface p-4 text-left shadow-card transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-lift active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent sm:w-80" data-id="element-267" data-mp="1gldi5m1jlp10">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold-soft text-gold" data-id="element-268" data-mp="1hd3gd1ng1zwg">
              <LightbulbIcon className="h-5 w-5" aria-hidden data-id="element-269" data-mp="1mcpuref0dm6u" />
            </span>
            <span className="min-w-0 flex-1" data-id="element-270" data-mp="1r857u456ze27">
              <span className="block text-xs font-semibold text-muted" data-id="element-271" data-mp="1w8jh1pij4u1t">Key insight</span>
              <span className="mt-0.5 block text-sm font-medium leading-snug text-ink" data-id="element-272" data-mp="20aegspktazdh">{insight}</span>
            </span>
            <ArrowRightIcon className="h-4 w-4 shrink-0 text-subtle transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden data-id="element-273" data-mp="258zf2jgi78za" />
          </button>
        </div>
      </div>
    </section>;
}